export default "__VITE_ASSET__C_ZK4Z6J__"